export default __webpack_public_path__ + "static/BusinessSolar-d1e3482d39d87d37afa87f02e1cb17b7.jpeg";